<div class="month-calendar">
  <div class="month-calendar-header">
    <button type="button" class="month-calendar-nav" (click)="step(-1)" i18n-aria-label aria-label="Previous month">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </button>
    <span class="month-calendar-title">{{ title() }}</span>
    <button type="button" class="month-calendar-nav" (click)="step(1)" i18n-aria-label aria-label="Next month">
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </button>
    <button type="button" class="month-calendar-today" (click)="thisMonth()" i18n>This month</button>
  </div>

  <div class="month-calendar-grid">
    @for (name of weekdayNames(); track $index) {
      <div class="month-calendar-weekday">{{ name }}</div>
    }

    @for (week of weeks(); track $index) {
      @for (cell of week; track cell.key) {
        <button
          type="button"
          class="month-calendar-cell"
          [class]="toneClass(cell)"
          [class.is-outside]="!cell.inMonth"
          [class.is-today]="cell.isToday"
          [class.is-weekend]="cell.isWeekend"
          [class.is-selected]="isSelected(cell)"
          [class.has-tone]="!!cell.day?.tone"
          [disabled]="!cell.inMonth"
          (click)="pick($event, cell)"
        >
          <span class="month-calendar-day-number">{{ cell.dayNumber }}</span>
          @if (cell.inMonth && cell.day) {
            @if (cell.day.value) {
              <span class="month-calendar-value">{{ cell.day.value }}</span>
            }
            @if (cell.day.caption) {
              <span class="month-calendar-caption">{{ cell.day.caption }}</span>
            }
            @if (shownChips(cell).length) {
              <span class="month-calendar-chips">
                @for (chip of shownChips(cell); track chip) {
                  <span class="month-calendar-chip">{{ chip }}</span>
                }
                @if (moreChips(cell)) {
                  <span class="month-calendar-chip is-more">+{{ moreChips(cell) }}</span>
                }
              </span>
            }
            @if (cell.day.fill !== undefined) {
              <span class="month-calendar-fill"><span [style.width.%]="fillPercent(cell)"></span></span>
            }
          }
        </button>
      }
    }
  </div>
</div>
